/**
 * 찜하기 — 카드 우측 상단 하트 토글.
 *
 * 버튼 자체를 서버가 로그인 상태에 따라 그린다. 비로그인 사용자에게 오는 것은
 * 링크(<a>)라 여기서 잡히지 않고 그대로 로그인 화면으로 간다.
 *
 * 카드는 홈 그리드·'더 보기'·찜 목록 어디에서나 나타나고 필터가 바뀌면 통째로
 * 교체되므로, 특정 컨테이너가 아니라 document 에 위임한다.
 *
 * 누른 즉시 하트를 바꾸고(낙관적 갱신) 실패하면 되돌린다 — 응답을 기다리는 동안
 * 아무 반응이 없으면 두 번 누르게 된다. REST 는 원하는 상태를 그대로 받으므로
 * (멱등) 되돌린 뒤 다시 눌러도 어긋나지 않는다.
 */
const InitAcademyFavorites = () => {
  const config = window.qrshopAcademy;

  if (!config?.restUrl || !config?.nonce) {
    return;
  }

  const setState = (button, on) => {
    const label = on ? '찜 해제' : '찜하기';

    button.setAttribute('aria-pressed', on ? 'true' : 'false');
    button.title = label;

    const text = button.querySelector('[data-academy-fav-label]');

    if (text) {
      text.textContent = label;
    }
  };

  // 헤더의 찜 개수. 0이면 숫자를 감춘다.
  const setCount = (count) => {
    if (typeof count !== 'number') {
      return;
    }

    document.querySelectorAll('[data-academy-fav-count]').forEach((el) => {
      el.textContent = String(count);
      el.hidden = count < 1;
    });
  };

  // 찜 목록 페이지에서 해제한 카드는 더 이상 이 목록에 속하지 않는다.
  // 홈 그리드에서 해제한 것이라면 카드를 그대로 둔다(다시 찜할 수 있어야 한다).
  const dropFromFavoritesPage = (button) => {
    const page = button.closest('[data-academy-favorites]');

    if (!page) {
      return false;
    }

    const grid = page.querySelector('.academy-grid');

    button.closest('.academy-card')?.remove();

    if (grid && grid.children.length === 0) {
      const empty = document.createElement('p');

      empty.className = 'academy-empty';
      empty.textContent = page.dataset.academyFavoritesEmpty || '';
      page.replaceChildren(empty);
    }

    return true;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-academy-fav]');

    if (!button) {
      return;
    }

    const next = button.getAttribute('aria-pressed') !== 'true';

    setState(button, next);
    button.disabled = true;

    try {
      const response = await fetch(`${config.restUrl}/favorites/${button.dataset.academyFav}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': config.nonce },
        body: JSON.stringify({ favorite: next }),
      });
      const data = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(data?.message || '요청에 실패했습니다.');
      }

      setState(button, !!data.favorited);
      setCount(data.count);

      // 카드째 사라졌다면 되살릴 버튼도 없다.
      if (!data.favorited && dropFromFavoritesPage(button)) {
        return;
      }
    } catch (error) {
      setState(button, !next);
      window.alert(error.message);
    }

    button.disabled = false;
  });
};

export default InitAcademyFavorites;
